{
  "version": 1,
  "asset_id": "e8e8c440-e838-4d9f-a066-25c6bc86da41",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/e8e8c440-e838-4d9f-a066-25c6bc86da41/beverly-hills-shingle-roof-underlayment-480w.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/e8e8c440-e838-4d9f-a066-25c6bc86da41/beverly-hills-shingle-roof-underlayment-480w.webp",
  "original_filename": "beverly-hills-shingle-roof-underlayment-480w.webp",
  "size": 26796,
  "content_type": "image/webp",
  "created_at": "2026-07-29T14:07:26Z"
}
